module.exports = __webpack_public_path__ + "img/adi_achla_kartiv_no.df5d15b2.png";